'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BarHeader = require('../../lib/BarHeader');

var _BarHeader2 = _interopRequireDefault(_BarHeader);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = require('merge-theme-hoc');

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'headerWrapper': 'BarHeader__headerWrapper___1tOVZ',
  'title': 'BarHeader__title___3Yc_T',
  'small': 'BarHeader__small___2CPVz',
  'medium': 'BarHeader__medium___1WY1g',
  'large': 'BarHeader__large___2oKY6',
  'subtitle': 'BarHeader__subtitle___2DgA6',
  'bottomBorder': 'BarHeader__bottomBorder___3GVMZ'
};

var DefaultBarHeader = (0, _mergeThemeHoc2.default)(style)(_BarHeader2.default);
DefaultBarHeader.displayName = 'DefaultBarHeader';
exports.default = DefaultBarHeader;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dibs-elements/dist/BarHeader/index.js
// module id = ./node_modules/dibs-elements/dist/BarHeader/index.js
// module chunks = 4